import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { ItemTypes } from './ItemTypes';
import { customColumnPath } from '../fieldPath';

const style = {
  cursor: 'move',
};
function RenderLabelsTypeOptions({ column, index, moveTr, id, removeLabel, addNewLabel, handleChange, pIndex, wholeArry }) {
  const ref = useRef(null);
  const { t } = useTranslation('common');

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveTr(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));

  return (
    <div className="mb-2 form-group d-flex w-100" key={id} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      <div className="colour-text-container">
        <div className="checkbox-content">
          <div className="checkbox-label no-label margin-auto">
            <input
              onChange={(e) => {
                handleChange(e.target.checked, customColumnPath(pIndex, 'labelColoursOptions', index, 'isLabelColourChecked').LABELCOLOURS_UPDATES);
              }}
              name={`labelColoursOptions${index}`}
              id={`labelColoursOptions${index}`}
              type="checkbox"
              checked={column?.isLabelColourChecked}
              value={column?.isLabelColourChecked}
            />
            <label htmlFor={`labelColoursOptions${index}`} className="chklabel" />
          </div>
        </div>
        <div className="color-content">
          <input
            type="color"
            id="coloeStyle1"
            className="form-control"
            value={column?.colourHexCode}
            onChange={(e) => handleChange(e.target.value, customColumnPath(pIndex, 'labelColoursOptions', index, 'colourHexCode').LABELCOLOURS_UPDATES)}
          />
          <label htmlFor="coloeStyle1" />
        </div>
        <input
          type="text"
          className="text-content f-14"
          value={column?.colourName}
          placeholder={t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.RENDER_LABEL_TYPES.ADD_COLOUR_NAME')}
          onChange={(e) => handleChange(e.target.value, customColumnPath(pIndex, 'labelColoursOptions', index, 'colourName').LABELCOLOURS_UPDATES)}
        />
      </div>
      <button className="btn btn-outline m-0 ml-2" id={column?.colourName}>
        <span className="icon-expand" />
      </button>
      {wholeArry.length - 1 === index ? (
        <button className="btn btn-outline m-0 ml-2" onClick={addNewLabel}>
          <span className="icon-add" />
        </button>
      ) : (
        <button className="btn btn-outline m-0 ml-2">
          <span className="icon-delete" onClick={() => removeLabel(index)} />
        </button>
      )}
    </div>
  );
}

export default RenderLabelsTypeOptions;
